import angular from 'angular';

import EquipmentUpdateService from './services/equipment-update.service';
import KeyboardKeysService from './services/keyboard-keys.service';
import SEquipmentUpdateComponent from './components/single-equipment-update/s-equipment-update.component';
import bEquipmentUpdateComponent from './components/bulk-equipment-update/b-equipment-update.component';

import columnsToggleComponent from './common/columns-toggle/columns-toggle.component';
import attrEditComponent from './common/attr-edit/attr-edit.component';
import ctrlSDirective from './common/ctrl-s.directive';
import numberModelDirective from './common/attr-edit/number-model.directive';

const EquipmentUpdateModule = angular.module('equipment.update', []);

EquipmentUpdateModule.service('equipmentUpdateService', EquipmentUpdateService)
  .service('keyboardKeysService', KeyboardKeysService)
  .directive('onCtrlS', ctrlSDirective)
  .directive('numberModel', numberModelDirective)
  .component('sEquipmentUpdate', SEquipmentUpdateComponent)
  .component('bEquipmentUpdate', bEquipmentUpdateComponent)
  .component('columnsToggle', columnsToggleComponent)
  .component('attrEdit', attrEditComponent);

export default EquipmentUpdateModule.name;
